import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { RequestTokenService } from "../../request-token.service";
import { DefinicaoFormSignature } from "../../../app/shared/Signature/DefinicaoFormSignature";
import { OpcaoFormSignature } from "../../../app/shared/Signature/OpcaoFormSignature";

const API_URL = `${environment.apiUrl}v6/Form`;

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(
    private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  // Form Definition Methods
  public GetDefinicoesForms(): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetDefinicoesForms`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetDefinicoesFormsPorId(id: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetDefinicoesFormsPorId/${id}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetDefinicoesFormPorNome(name: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetDefinicoesFormPorNome/${name}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public CriarDefinicaoForm(signature: DefinicaoFormSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/CriarDefinicaoForm`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public AtualizarDefinicaoForm(signature: DefinicaoFormSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/AtualizarDefinicaoForm`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public DeletarDefinicaoForm(id: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.delete<any>(`${API_URL}/DeletarDefinicaoForm/${id}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  // Form Option Methods
  public GetOpcoesForm(formId: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetOpcoesForm/${formId}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetOpcaoFormPorId(id: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetOpcaoFormPorId/${id}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetDefinicoesFormPorValor(formId: string, value: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetDefinicoesFormPorValor/${formId}/${value}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public CriarOpcaoForm(signature: OpcaoFormSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/CriarOpcaoForm`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public AtualizarOpcaoForm(signature: OpcaoFormSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/AtualizarOpcaoForm/`, signature, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public DeletarOpcaoForm(id: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.delete<any>(`${API_URL}/DeletarOpcaoForm/${id}`, options)
      .pipe(
        catchError(this.handleError)
      );
  }
} 